export default __webpack_public_path__ + "static/media/banner.2341b8e2.jpg";